import { useCallback } from 'react';
import { FreshdeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm2/FreshdeskTicketsForm';
import { FreshdeskHelpCenterForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateFreshdeskIntegrationPopup/FreshdeskIntegrationForm2/FreshdeskHelpCenterForm';
import type { IntegrationFormProps } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/integrationFormProps';

export type FreshdeskIntegrationType = 'Help Center' | 'Tickets';

export const FreshdeskIntegrationForm2 = ({
  freshdeskIntegrationType,
  prevStep = () => {},
  closePopup = () => {},
}: Pick<IntegrationFormProps, 'prevStep' | 'closePopup'> & {
  freshdeskIntegrationType?: FreshdeskIntegrationType;
}) => {
  const renderForm = useCallback(() => {
    switch (freshdeskIntegrationType) {
      case 'Help Center':
        return (
          <FreshdeskHelpCenterForm
            freshdeskIntegrationType={freshdeskIntegrationType}
            prevStep={prevStep}
            closePopup={closePopup}
          />
        );
      case 'Tickets':
        return (
          <FreshdeskTicketsForm
            freshdeskIntegrationType={freshdeskIntegrationType}
            prevStep={prevStep}
            closePopup={closePopup}
          />
        );
    }
  }, [freshdeskIntegrationType]);

  return renderForm();
};
